import { render, staticRenderFns } from "./PrimaryNavigation.vue?vue&type=template&id=278c363e&"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports